import angular from 'angular';
import metricsService from './metrics/metrics.service';
import gProfileService from './bbva-gapis/gprofile.service';
import AccessTokenService from '../common/interceptors/accessToken/accessToken.service';

let mobileModule = angular

  .module('mobile', [])

  .service('accessTokenService', AccessTokenService)
  .service('metricsService', metricsService)
  .service('gProfileService', gProfileService)

  .name;

export default mobileModule;



// WEBPACK FOOTER //
// ./client/app/mobile/mobile.module.js